import React from 'react';
import './Stats.css';
import logoPng from '../../assets/logoFab2.png';

const Stats = () => {
    const stats = [
        {
            id: 1,
            number: "500+",
            label: "Wholesale fabrics",
        },
        {
            id: 2,
            number: "125+",
            label: "Global suppliers Tie-ups",
        },
        {
            id: 3,
            number: "8000+",
            label: "Customer Trusted us.",
        },
    ]

    return (
        <div className='stats'>
            <h3 className='stats_header' data-aos="fade-down"><img   src={`${logoPng}?time=${Date.now()}`}
              alt="logo"
              style={{
                width: "100px",
                marginTop: "0.5rem",
              }} /></h3>
            <h2 className='stats_title' data-aos="fade-down">Success at a glace</h2>
            <p className='stats_description' data-aos="fade-down">At FabInsta, we're committed to delivering exceptional results and driving growth. Here are some highlights of our performance.</p>
            <div className='stat_details' data-aos="fade-down">
                {stats.map((stat) => (
                    <div className='stat_item' key={stat.id}>
                        <span className='stat_vertical'></span>
                        <div>
                            <p className='stat_number'>{stat.number}</p>
                            <p className='stat_label'>{stat.label}</p>
                        </div>
                    </div>
                ))
                }
            </div>
        </div>
    );
}

export default Stats;
